module.exports = __webpack_public_path__ + "static/media/qzrn-awesome-graphic.9df31546.png";